<template>
  <div :class="classObj" class="app-wrapper">
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <navbar />
      <app-main />
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'

export default {
  name: 'Layout',
  components: { Navbar, Sidebar, AppMain },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #F0F4F8;
}

.sidebar-container {
  width: $sidebar-width;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(180deg, #0A1A14 0%, #0F2027 100%);
  transition: width 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1001;
  overflow: hidden;
  box-shadow: 4px 0 20px rgba(0,0,0,0.15);
}

.main-container {
  min-height: 100%;
  transition: margin-left 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  margin-left: $sidebar-width;
  position: relative;
  display: flex;
  flex-direction: column;
}

.hideSidebar {
  .sidebar-container { width: $sidebar-collapsed-width; }
  .main-container { margin-left: $sidebar-collapsed-width; }
}

.withoutAnimation {
  .sidebar-container,
  .main-container { transition: none; }
}
</style>
